
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      passwordReseted: false,
      newPassword: "",
      confirmPassword: "",
      matchError: false,
      lengthError: false,
    };
  },
  methods: {
    closeModal() {
      this.passwordReseted = false;
      this.matchError = false;
      this.$emit("closeChangePasswordModal");
    },
    checkPassword() {
      let error = false;
      this.matchError = false;
      this.lengthError = false;
      if (this.newPassword !== this.confirmPassword) {
        this.matchError = true;
        error = true;
      }
      if (this.newPassword.length <= 8) {
        this.lengthError = true;
        error = true;
      }
      if (error) {
        this.newPassword = "";
        this.confirmPassword = "";
      }
      return !error;
    },
    async updatePassword() {
      if (this.checkPassword() === true) {
        const newPasswordResponse = await axios.patch(
          `/users/me/updatepassword`,
          {
            password: this.newPassword,
          }
        );
        this.passwordReseted = newPasswordResponse.status < 300;
      }
    },
  },
});
